export default __webpack_public_path__ + "static/media/yummy.a73b52db.png";